module.exports = __webpack_public_path__ + "static/media/rz_1_a_wing_by_radiusss.d90faa3d.svg";